import { FormattedMessage } from 'react-intl';

import { FormField } from '../../../../forms/formField/index';
import { numbersOnly } from '../../../../forms/helpers/normalisers';

export const AnnualProfitQuestion = (props) => {
    const { onChange } = props;

    return (
        <FormField
            className="fs-exclude"
            label={
                <FormattedMessage
                    id="_.your_company.annual_profit"
                    defaultMessage="Last 12 months profit (before tax)"
                />
            }
            name="annualProfit"
            id="annualProfit"
            onChangeHandler={onChange}
            normalize={numbersOnly}
        />
    );
};
